// PreferenceUnitsVolume.jsx
import React, { useState, useCallback, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import update from 'react-addons-update'
import { FormattedMessage, injectIntl } from 'react-intl'
import { SelectInput } from '../Inputs/Inputs'
import {
  CapitalButton,
} from '../Navigation/Buttons'

import styles from '../../../../css/devicePage.module.css'

import AppDispatcher from '../../../dispatchers/AppDispatcher'

const PreferenceUnitsVolume = ({ user, backToUser, intl }) => {
  const {
    data: {
      locale,
    },
  } = user
  const {
    unitsOfVolume = 'acreFeet',
  } = locale || {}

  const [state, setState] = useState({
    locale: {
      unitsOfVolume,
      ...locale,
    },
    invalid: false,
  })

  const goBackOnce = useRef(false)

  useEffect(() => {
    if (
      user.saved === true &&
      goBackOnce.current === false
    ) {
      goBackOnce.current = true
      setTimeout(() => {
        backToUser()
      }, 200)
    }
  }, [user.saved, backToUser])

  useEffect(() => {
    return () => {
      AppDispatcher.dispatch({
        action: 'unload-user-change',
      })
    }
  }, [])

  const appDispatch = useCallback(() => {
    AppDispatcher.dispatch({
      action: 'update-user',
      userID: user.id,
      change: {
        locale: state.locale,
      },
    })
  }, [user.id, state.locale])

  const saveButtonFunction = useCallback(() => {
    appDispatch()
  }, [appDispatch])

  const handleChange = useCallback((field, value, callback) => {
    setState((prevState) => {
      const newState = update(prevState, {
        locale: {
          [field]: { $set: value },
        },
        invalid: { $set: false },
      })
      return newState
    })
    if (callback) callback()
  }, [])

  const childChange = useCallback((event) => {
    handleChange(event.target.name, event.target.value)
  }, [handleChange])

  const {
    formatMessage,
  } = intl

  const options = {
    unitsOfVolumeOptions: [
      {
        value: 'acreInch',
        name: formatMessage({
          id: 'profile.unitsOfVolume.acreInch',
          defaultMessage: 'Acre-Inch (ac-in)',
          description: '',
        }),
      },
      {
        value: 'acreFeet',
        name: formatMessage({
          id: 'profile.unitsOfVolume.acreFeet',
          defaultMessage: 'Acre-Feet (ac-ft)',
          description: '',
        }),
      },
      {
        value: 'gallons',
        name: formatMessage({
          id: 'profile.unitsOfVolume.gallons',
          defaultMessage: 'Gallons (gal)',
          description: '',
        }),
      },
      {
        value: 'cubicFeet',
        name: formatMessage({
          id: 'profile.unitsOfVolume.cubicFeet',
          defaultMessage: 'Cubic-Feet (ft³)',
          description: '',
        }),
      },
      {
        value: 'hectareM',
        name: formatMessage({
          id: 'profile.unitsOfVolume.hectareM',
          defaultMessage: 'Hectare-M (ha-m)',
          description: '',
        }),
      },
      {
        value: 'liters',
        name: formatMessage({
          id: 'profile.unitsOfVolume.liters',
          defaultMessage: 'Liters (l)',
          description: '',
        }),
      },
      {
        value: 'cubicM',
        name: formatMessage({
          id: 'profile.unitsOfVolume.cubicM',
          defaultMessage: 'Cubic Meters (m³)',
          description: '',
        }),
      },
    ],
  }

  let saveButtonStyle = `${styles.saveButton} saveButton`
  if (state.invalid) {
    saveButtonStyle = `${styles.saveButton} saveButton ${styles.saveButtonHidden}`
  } else if (user.saved === true) {
    saveButtonStyle = `${styles.saveButton} saveButton ${styles.saveButtonSuccess}`
  } else if (user.saved === 'error') {
    saveButtonStyle = `${styles.saveButton} saveButton ${styles.saveButtonError}`
  }

  return (
    <div>
      <section className={`${styles.simpleLink} ${styles.simpleLinkBorderPhysical}`}>
        <h5>
          <FormattedMessage
            id='profile.unitsOfVolume.name'
            defaultMessage='Units of Volume'
            description='Units of Volume'
          />
        </h5>
        <div className={styles.simpleLinkValueEdit}>
          <SelectInput
            value={state.locale.unitsOfVolume || 'acreFeet'}
            field='unitsOfVolume'
            childChange={childChange}
            options={options.unitsOfVolumeOptions}
            style={styles.settingSelectInput}
          />
        </div>
      </section>
      <section>
        <FormattedMessage
          id='setting.save'
          defaultMessage='SAVE'
          description='SAVE label'
        >
          {(txt) => (
            <CapitalButton
              text={txt}
              buttonFunction={saveButtonFunction}
              hSize='h2'
              style={saveButtonStyle}
            />
          )}
        </FormattedMessage>
      </section>
    </div>
  )
}

PreferenceUnitsVolume.propTypes = {
  user: PropTypes.object.isRequired,
  backToUser: PropTypes.func.isRequired,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }),
}

export default injectIntl(PreferenceUnitsVolume)
